"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "NDSLib", {
  enumerable: true,
  get: function get() {
    return _ndsLib["default"];
  }
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _unescape = _interopRequireDefault(require("unescape"));

var _nodeToNdsComponent = _interopRequireDefault(require("./lib/node-to-nds-component"));

var _ndsLib = _interopRequireDefault(require("./lib/nds-lib"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var HtmlToNds = function HtmlToNds(_ref) {
  var html = _ref.html,
      decode = _ref.decode,
      componentDict = _ref.componentDict,
      forceWhitelist = _ref.forceWhitelist;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, (0, _htmlReactParser["default"])(decode ? (0, _unescape["default"])(html) : html, {
    replace: (0, _nodeToNdsComponent["default"])(componentDict, forceWhitelist)
  }));
};

HtmlToNds.propTypes = {
  html: _propTypes["default"].string.isRequired,

  /**
   * Flag to indicate the component should convert HTML entities to HTML characters
   * e.g. &gt; converts to >
   * Inefficient, and not recommended -- rather explicitly add expected entities to `componentDict` prop
   */
  decode: _propTypes["default"].bool,

  /**
   * Flag to indicate the component should explicitly whitelist the contents of `componentDict`
   */
  forceWhitelist: _propTypes["default"].bool,

  /**
   * Object that provides custom function mappings for HTML node conversion
   */
  componentDict: _propTypes["default"].objectOf(_propTypes["default"].func)
};
HtmlToNds.defaultProps = {
  decode: false,
  forceWhitelist: false,
  componentDict: {}
};
var _default = HtmlToNds;
exports["default"] = _default;